import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonNavBar from "views/components/CommonNavBar";
import styles from "./Service.module.less";
import { getQAList } from "api/mine";
import DSBridge from "dsbridge";
import { getJumpLink } from "api/home";
import { Toast } from "react-vant";

const _ = require("lodash");

function Service() {
  const navigate = useNavigate();
  const [currentPage] = useState(1);
  const [title, setTitle] = useState("");
  const [questionData, setQuestionData] = useState([]);
  const [jumpLink, setJumpLink] = useState("");

  const getQuestionList = () => {
    getQAList(currentPage, title).then((res) => {
      if (res.data) {
        let data = res.data?.data;
        if (Array.isArray(data) && data.length > 0) {
          data.sort((a, b) => b.sort - a.sort); // 降序排序
          setQuestionData(data);
        }
      }
    });
  };

  const handleChange = (e) => {
    delayedSearch(e.target.value);
  };

  //延迟防抖
  const delayedSearch = _.debounce((val) => {
    setTitle(val);
  }, 250);

  useEffect(() => {
    getQuestionList();
  }, [currentPage, title]);

  const handleClickWeixin = () => {
    if (!jumpLink) {
      Toast.info("暂无跳转链接");
      return;
    }
    try {
      if (DSBridge.hasNativeMethod("route.navigation")) {
        DSBridge.call(
          "route.navigation",
          {
            route: "miniProgram",
            mid: "gh_ce82ce6b1629",
            path: jumpLink,
          },
          (back) => {
            console.log(back);
          }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getJumpLinkData = async () => {
    try {
      const res = await getJumpLink();
      if (res.code === 200) {
        setJumpLink(res.data?.path);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getJumpLinkData();
  }, []);

  return (
    <div className={styles["main-container"]}>
      <CommonNavBar
        onClickBack={() => {
          navigate(-1);
        }}
      />
      <img
        className={styles["top-banner"]}
        src={require("@/images/mine/ic_mine_header_bg.png")}
      />
      <div className={styles["top-container"]}>
        <div className={styles["top-right"]}>
          <div className={styles["top-right-text1"]}>欢迎体验</div>
          <div className={styles["top-right-text2"]}>口袋领航外教在线客服</div>
        </div>
      </div>
      <div className={styles["search-QA"]}>
        <div className={styles["qa-text"]}>常见问题</div>
        <div className={styles["qa-input"]}>
          <img
            className={styles["qa-icon"]}
            src={require("@/images/mine/ic_mine_sousuo.png")}
          />
          <input placeholder="问题搜索" type="text" onChange={handleChange} />
        </div>
      </div>
      <div className={styles["rv-list"]}>
        {questionData.map((item) => {
          return (
            <div
              className={styles["tab-list"]}
              key={item.id}
              onClick={() =>
                navigate(
                  `/mine/questContent?title=${encodeURIComponent(
                    item.title
                  )}&content=${encodeURIComponent(
                    item.content
                  )}`
                )
              }
            >
              <div className={styles["tab-item"]}>{item.title}</div>
              <img
                className={styles["tab-item-icon"]}
                src={require("@/images/mine/ic_mine_r_arrow.png")}
              />
            </div>
          );
        })}
      </div>
      <div className={styles["tab-container"]}>
        <div className={styles["tab-item"]} onClick={handleClickWeixin}>
          <img
            className={styles["img1"]}
            src={require("@/images/mine/ic_mine_wechat.png")}
          />
          <div className={styles["tab-text"]}>微信客服</div>
        </div>
      </div>
    </div>
  );
}

export default Service;
